export default __webpack_public_path__ + "static/media/moi.d04184a0.png";